import React, { FC } from 'react';
import { Box } from '@mui/material';


export const Summary:FC = () => {

  return (
    <Box>
        Podsumowanie
    </Box>
  );
};